import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Switch, Route } from 'react-router-dom'
import { checkLogin, logout } from '../actions'
import Header from '../components/Header'
import SideMenu from '../components/SideMenu'
import Notification from '../components/Notification'
import ReportForm from '../components/ReportForm'
import Home from './Home'
import Document from './Document'
import Organization from './Organization'
import Plan from './Plan'
import Setting from './Setting'
import Nippo from './Nippo'

class App extends Component {
  componentWillMount() {
    this.props.checkLogin()
  }
  render() {
    const { user, logout, location } = this.props
    return (
      user.uid ?
        <div id="container">
          <SideMenu logout={logout} url={location.pathname} />
          <main>
            <Notification />
            <Header />
            <Switch>
              <Route exact path='/' component={Home} />
              <Route path='/report' component={ReportForm} />
              <Route path='/document' component={Document} />
              <Route path='/organization' render={() => <Organization url={location.pathname} />} />
              <Route path='/plan' render={() => <Plan url={location.pathname} />} />
              <Route path='/setting' component={Setting} />
              <Route path='/nippo' component={Nippo} />
            </Switch>
          </main>
        </div>
      :
        <div>Loading...</div>
    )
  }
}

export default connect(
  state => ({ user: state.user }),
  { checkLogin, logout }
)(App)



// WEBPACK FOOTER //
// ./src/containers/App.js